import React from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import Button, { ButtonGroup } from '@atlaskit/button';
import InlineMessage from '@atlaskit/inline-message';

const getAppearance = (value) => {
  if (value === 'success') {
    return 'confirmation';
  } if (value === 'info') {
    return 'connectivity';
  }
  return value;
};

const TypeInlineMessage = props => (
  <div style={{ margin: '12px 0 0 0' }}>
    <InlineMessage
      {...props}
      title={props.title}
      type={getAppearance(props.appearance)}
    >
      {props.children}
      <div style={{ margin: '12px 0 0 0' }}>
        <ButtonGroup>
          {props.actions.map(action => (
            <Button key={action.text} {...action}>{action.text}</Button>
          ))}
          <Button onClick={props.onClose}>Close</Button>
        </ButtonGroup>
      </div>
    </InlineMessage>
  </div>
);

TypeInlineMessage.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.object),
  appearance: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
};

TypeInlineMessage.defaultProps = {
  actions: [],
  appearance: 'info',
  children: '',
  title: 'Click to view the message',
};

export default TypeInlineMessage;
